import React, { SyntheticEvent } from 'react';
import { Autocomplete, TextField } from '@biq/apex-ui';
import { useDictionaryList } from '../../../../hooks';
import {
    AutocompleteChangeDetails,
    AutocompleteChangeReason,
    ListItem,
    Typography,
} from '@mui/material';
import { styles } from './job-manager-chain-selector-helper';
import { globalEllipsisTextStyles } from 'lib';

interface ChainSelectorProps {
    onChange: (
        event: SyntheticEvent<Element, Event>,
        value: any,
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<any> | undefined
    ) => void;
    required?: boolean;
    error?: boolean;
    errorText?: string;
    defaultValue?: string;
}

// NOTE: Possibly rename and replace chain selector at components level. This requires further refactoring in other pages.
// Missael: To refactor the chain selector for all job types in next ticket.
export const JobManagerChainSelector = ({
    onChange,
    required = false,
    error = false,
    errorText,
    defaultValue,
    ...other
}: ChainSelectorProps): React.JSX.Element => {
    const { data: chainsData, isLoading } = useDictionaryList();

    return (
        <Autocomplete
            {...other}
            options={
                !isLoading && chainsData
                    ? chainsData?.data.map((chain) => chain.name)
                    : []
            }
            disableClearable={!defaultValue}
            defaultValue={defaultValue}
            onChange={onChange}
            sx={styles.autoCompleteStyles}
            renderInput={(params): React.JSX.Element => (
                <TextField
                    {...params}
                    size='medium'
                    required={required}
                    label='Chain'
                    variant='outlined'
                    error={error}
                    errorText={errorText}
                />
            )}
            ListboxProps={{
                sx: styles.smartContractAutocompleteChainFieldHeight,
            }}
            renderOption={(props, option): React.JSX.Element => (
                <ListItem {...props}>
                    <Typography sx={globalEllipsisTextStyles}>
                        {option}
                    </Typography>
                </ListItem>
            )}
        />
    );
};
